import React, { Component } from "react";

import SJNoData from '../../core/SJNoData'
import _ from 'lodash'
import {Icon, Avatar} from 'antd'
import {  Button as SVAButton } from 'antd';

class InvBoardTable extends Component{
    reloadMySojReservationReviewPageSV=(masterCustOffer )=>(e)=>{
        let me = this
        let ob = masterCustOffer.o
        let svcustProfile = masterCustOffer.svcustProfile
        console.log('sv****Got the nov19  page reloadMySojReservationReviewPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SV nov19 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        /*
        me.props.sjofferselectparent(cidOffer, ob.flight_space_key, svcustProfile) 
      */
        

    }


    reloadSJReviewPageSV=(oroomselected_orate )=>(e)=>{
        let me = this   
       
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(oroomselected_orate)
        /*
        oroomselected_orate = {
            assetCode : "DBL.KG-1",
            orate : orate 
        }
        */
        console.log('soj**')
        console.log(me.props)
        console.log(me.props.priceInfo.o)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }

       
        me.props.invofferselectparent(cidOffer, oroomselected_orate) 
       
        // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    getFSKReserveHtmlButtonTable(oroomselected_orate,svcustProfile){
        let me = this
        let customerId = -1
        // o = orate
       
        /*
         console.log('sv******** getFSKReserveHtmlButton start ')
        console.log(o)
        console.log(svcustProfile)
        console.log('sv******** getFSKReserveHtmlButton end')
onClick={me.reloadSJReviewPageSV(o).bind(this)}
        */
        if(!svcustProfile){
            return( <SVAButton onClick={me.reloadINVReviewPageSV(oroomselected_orate).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
            )
           
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
        if(customerId > 0){
            let masterCustOffer = {
                "svcustProfile": svcustProfile,
                "o":oroomselected_orate
            }
            return( <SVAButton onClick={me.reloadMySojReservationReviewPageSV(masterCustOffer).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >MyFlightReserve </SVAButton>
            )
            /*
            return (<Button  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            */

        }else{
            /*
            let oroomselected_orate = {
                assetCode : "DBL.KG-1",
                orate : o 
            }
            */
            //working July2y25 it will be hotelid extracted from ratekey
            return(  <SVAButton onClick={me.reloadSJReviewPageSV(oroomselected_orate).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>
           )
           
            /*
             {
                this.reloadHotelPageSV(o).bind(this)
            }
            
            return( <SVAButton onClick={me.reloadSJReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >SJ IReserve </SVAButton>)
            */
            /*
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >IReserve</Button>)
            */
        }
        
    }
    
    constructor(props){
        super(props)
        let me = this
        this.state = {
            randomString: `_${this.createRandomString()}_`
        }
        //getFSKReserveHtmlButtonTable
        this.getFSKReserveHtmlButtonTable = this.getFSKReserveHtmlButtonTable.bind(me)
        this.handleCellClick = this.handleCellClick.bind(me)
        this.reloadINVReviewPageSV = this.reloadINVReviewPageSV.bind(me)
    }

    createRandomString(){
        return Math.random().toString(36).substring(7)
    }

    handleCellClick(e){
        let me = this
        console.log(e)
        e.preventDefault();
        console.log(e)
        let recordKey = e.target.innerText;
        console.log(recordKey)
/*
        if(!recordKey){
            return
        }
        console.log(this.props)
        const appData = me.props.priceInfo.o.assets.filter((row, idx)=>{
           return row['code'] === recordKey
        })
        this.props.hostDetails(recordKey , appData)
        */
    }

    render(){
        //let pnpData = this.props.data, allTree, appKeys, hostRows, appRowData=[]
        let hostRows = null
        let pnpData = [{
                        "code": "SGL.ST",
                        "name": "STANDARD SINGLE BASIC ROOM",
                        "rates": [
                            {
                                "rateKey": "20250615|20250616|W|1|311|DUS.Z1|NRF-RO|RO||1~1~0||N@07~~2064d~1627120419~N~~~NRF~~3E63FEAE94684DF174743279490405AAUK0003000100010721a44",
                                "rateClass": "NRF",
                                "rateType": "BOOKABLE",
                                "net": "68.26",
                                "allotment": 8,
                                "paymentType": "AT_WEB",
                                "packaging": false,
                                "boardCode": "RO",
                                "boardName": "ROOM ONLY",
                                "cancellationPolicies": [
                                    {
                                        "amount": "68.26",
                                        "from": "2025-05-15T23:59:00+02:00"
                                    }
                                ],
                                "taxes": {
                                    "taxes": [
                                        {
                                            "included": false,
                                            "amount": "2.20",
                                            "currency": "EUR",
                                            "clientAmount": "2.20",
                                            "clientCurrency": "EUR"
                                        }
                                    ],
                                    "allIncluded": false
                                },
                                "rooms": 1,
                                "adults": 1,
                                "children": 0,
                                "promotions": [
                                    {
                                        "code": "073",
                                        "name": "Non-refundable rate. No amendments permitted",
                                        "remark": "Non-refundable rate. No amendments permitted"
                                    }
                                ]
                            }]

                       
        }]
        let svcustProfile = {
            customerId : -1
        }
        const { priceInfo} = this.props
        if(this.props.svcustProfile){
            svcustProfile = this.props.svcustProfile
        }
   
       
        if(this.props.data){

            let sojData  = this.props.data.assets
            console.log('jul3***')
            console.log(this.props.data)
            console.log(sojData)
            pnpData = sojData?  sojData: []
        }
       
        if(pnpData.length === 0){
            hostRows = <SJNoData />
        }else{
            if(this.props.plot == 'RESULT'){
                hostRows = pnpData.map( (o, idx)=>{
                    let cur = 'USD'
                    let rname = 'NA'
                    let priceNet = 0
                    let selectorNme = 'legend-pnp-not-available'
                    let orate = null
                    if(o.rates){

                        let rateSelected = _.find(o.rates, function(sp){
                            // console.log('facob_one find start', hid) 
                             //console.log(sp)
                             //console.log('facob_one find start', hid) 
                             if( (sp["paymentType"] == "AT_WEB") &&(sp["rateClass"] == "NOR") &&(sp[ "rateType"] == "RECHECK") ){
                                 return true
                             }else{
                                 return false
                             }
                             // return sp['code'] === hid
                         })

                      //  let rateKey1 = (rateSelected && rateSelected.rateKey ) ?  rateSelected.rateKey : o.rates[0].rateKey
                         orate = (rateSelected && rateSelected.rateKey ) ? rateSelected : o.rates[0]
                        priceNet = orate.net
                        
                        if(orate['taxes']){
                            let taxes = orate['taxes']
                            let tax1 = null
                            if(taxes[0]){
                                tax1 = taxes[0]
                                cur = tax1["clientCurrency"]
                            }

                        }
                    }
                    
                    let priceNetCur = `${cur} ${priceNet}`
                    //"SGL.ST"
                    //if(o.code == 'SGL.ST'){
                    rname = o.name? o.name : 'NA'
                    let code = o.code ? o.code : 'SGL.ST'
                    let oroomselected_orate ={
                        "assetCode" : code,
                        "orate" : orate 
                    }
                    let {roomCode, maxAdults, maxChildren} = o
                    if(code == 'SGL.ST'){
                        selectorNme = 'legend-pnp-match-available'
        
                    }else if(o.RESULT == "Non Symmetrical"){
                        selectorNme = 'legend-pnp-unmatch-available'
                    }
                   
                    return(
                      
       
                            <div className="row board-table-row pointer" data-name="ASPT">
                                    <div className="col-md-6 break-word">{rname}</div>
                                    <div className="col-md-2">{priceNetCur}</div>         
                                    
                                    
                                    <div className="col-md-2">            
                                        <div className="icon-wrapper">
                                                <Icon style={{ color: 'rgb(153, 17, 94)', fontSize:'20px' }} type="usergroup-add" />
                                                
                                                <Icon style={{ color: 'rgb(250, 163, 52)' ,fontSize:'14px' }} type="user" />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                    {this.getFSKReserveHtmlButtonTable(oroomselected_orate,svcustProfile)}
                                    </div>
                            </div>
                       
                    )
                }  )

            }else{
                hostRows = pnpData.map( (o, idx)=>{
                    let selectorNme = 'legend-pnp-not-available'
                    if(o.DB_SYMMETRY == 'Match'){
                        selectorNme = 'legend-pnp-match-available'
        
                    }else if(o.DB_SYMMETRY == 'Not Match'){
                        selectorNme = 'legend-pnp-unmatch-available'
                    }
                            
                    return(
                        <div className="row board-table-row pointer" data-name="ASPT">
                                <div className="col-md-8 break-word">{o.APPLICATION_NAME}</div>
                                <div className="col-md-2">            
                                    <div className={o.rate}></div>
                                </div>
                                <div className="col-md-2">            
                                    <div className={selectorNme}></div>
                                </div>
                            </div>
                    )
                }  )

            }
           

        }
        
        return(
            <div className="board-table-wrapper">
                <div className="row board-table-header flex-center-vertical ">
                    <div className="col-md-6"><b>Room Type</b></div>
                    <div className="col-md-2"><b>Net Price</b></div>
                    <div className="col-md-2"><b>Number OF Guests</b>
                    <div className="col-md-2"><b>Button</b></div>   </div>           
                </div>
                {/* 
                 <div  onClick={(e)=>this.handleCellClick(e)}  className="board-table">
                 */}
                <div  onClick={(e)=>this.handleCellClick(e)}  className="board-table">
                {hostRows}     
                     
                </div>        
            </div>        
        )
    }
    /*sjjul16 start*/
    reloadINVReviewPageSV=(ob )=>(e)=>{
        //we have may rate keys for the hotel , the ratekey can be promotion that later can be overriden by call from DB for custprofile
        let me = this
        console.log('sv****reloadINVReviewPageSV JUL16**8 FOR ROOM selecetd by customer needs customerId')
        console.log(ob)
        console.log( ob.price_key)
        let cidOffer = null

        if(me.props.priceInfo.o){
            console.log('SVJUL16 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }

        /*
         me.props.sjofferselectparent(cidOffer, ob.flight_space_key) 
       
        */
       //uncomment for calling review page and the filter the room based on rateKey
       // me.props.invofferselectparent(cidOffer, ob.price_key) 
       

    }
    /*sjjul16 end */
    
}

export default InvBoardTable